exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my-border[data-v-2c3d0c8b]{border-right:1px solid #e9edf2}", "", {"version":3,"sources":["/vercel/path0/ui/src/views/Truckdetail.vue"],"names":[],"mappings":"AACA,4BACE,8BAAgC,CACjC","file":"Truckdetail.vue","sourcesContent":["\n.my-border[data-v-2c3d0c8b] {\n  border-right: 1px solid #e9edf2;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c3d0c8b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Truckdetail.vue
// module id = 1596
// module chunks = 9